@if(config().type == 'confirmation'){
<div class="modal-header justify-content-between border border-0">
  <h4 class="modal-title fs-5">
    {{ config().title! | translate }}
  </h4>
  <button-component [config]="configs().btn.close" />
</div>
<div class="divider m-0"></div>

<div class="modal-body my-3">
  <p class="my-0">
    {{ config().description! | translate }}
  </p>
</div>
<div class="divider m-0"></div>

<div class="modal-footer border border-0">
  <button-component [config]="config().actions.cancel!" />
  <button-component [config]="config().actions.confirm" />
</div>
} @else if(config().type == 'custom'){ @if(config().title){
<div class="modal-header justify-content-between border border-0">
  <h4 class="modal-title fs-5">
    @if(typeof config().title == 'string'){
    {{ config().title! | translate }}
    } @else {
    {{ config().title!.key | translate : config().title!.params }}
    }
  </h4>
  <button-component [config]="configs().btn.close" />
</div>
<div class="divider m-0"></div>

}

<div class="modal-body">
  <ng-container
    *ngComponentOutlet="config().body.content; inputs: config().body.data"
  />
</div>

@if(config().actions){
<div class="divider m-0"></div>
<div class="modal-footer border border-0">
  @for(action of config().actions; track action){
  <button-component [config]="action" />
  }
</div>
} } @else if(config().type == 'progress'){
<div class="modal-header justify-content-between border border-0">
  <h4 class="modal-title fs-5 fw-semibold">
    {{ config().title! | translate }}
  </h4>
  <!-- <button-component [config]="configs.btn.close" /> -->
</div>
<div class="divider m-0"></div>

<div
  class="modal-body d-flex flex-column align-items-center justify-content-center pt-0 pb-4"
>
  @if(config().loader.type == 'spinner'){
  <icon
    [icon]="icons.spinner"
    size="150"
    [color]="config().loader.color || 'primary'"
  />
  }
  <span class="fs-6 fw-medium text-center">{{
    config().message | translate
  }}</span>
</div>
} @else {
<p>One fine body&hellip;</p>
}
